/*
* How it works
*
* Run init before all the rest scripts
* Run postMessage to initiate content hydration,
* pass type to define what content should be received from web worker, use same type in worker.js,
* pass callback that will be called when web worker sends message with given type and data
* in arguments
* Once all callbacks are done, worker will be terminated
* */
export default {
    worker: new Worker(new URL('./worker.js', import.meta.url)),

    events: {},

    postMessage(type, callback) {
        this.events[type] = {
            callback,
            done: false
        }
        this.worker.postMessage(type)
    },

    init(options = {}) {
        this.worker.addEventListener('message', (e) => {
            const type = e.data.type
            const data = e.data.data

            this.events[type].callback(data)
            this.events[type].done = true

            if (Object.values(this.events).some(event => !event.done)) return;

            this.worker.terminate()
            if (options.onTerminate) options.onTerminate()
        })
    }
}